import BaseStore from './BaseStore'

export class InformGroupStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'inform_groups'
  }
}

export default new InformGroupStore()


// WEBPACK FOOTER //
// ./src/stores/InformGroupStore.js